export const nodeTypes = {
  business: 'a Business',
  adAccount: 'an Ad Account',
  page: 'a Page',
  pixel: 'a Pixel',
  instagramAccount: 'an Instagram Business Account',
  merchant: 'a Merchant Center Account',
  adBeneficiary: 'an Ad Beneficiary',
  adPayer: 'an Ad Payer',
  whatsappAccount: 'a WhatsApp Business Account',
  whatsappPhoneNumber: 'a WhatsApp Phone Number',
};

export const AVAILABLE_TRACKING_EVENTS = [
  // 'PageView', // temporarily disabled — to be re-added in a follow-up PR
  'ViewContent',
  'AddToCart',
  'Purchase',
  'AddToWishlist',
  'CompleteRegistration',
  'Subscribe',
  'Search',
  'InitiateCheckout',
  'AddPaymentInfo',
];

export const metaEventsManagerPixelUrl = (pixelId) =>
  `https://business.facebook.com/events_manager2/list/dataset/${pixelId}/settings`;
